module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.isEdit ? 'Edit' : 'Add') + " Allergen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "column text-xs-left",
    staticStyle: {
      "width": "65px"
    },
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allergens.names), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "65px"
      }
    }, [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "text",
        "value": item.name
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1)])
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "align-center": ""
    }
  }, [(_vm.languages.length > 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "outline": "",
      "type": "button"
    },
    slot: "activator"
  }, [_vm._v("\n          Add language\n          "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang, index) {
    return (lang !== _vm.language) ? _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addLang(lang.value, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(lang.text) + "\n            ")])], 1) : _vm._e()
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cecef4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AllergensModal.vue
// module id = 587
// module chunks = 25